import Card from '../Card';
import Constants from '../../constants/Constants';

export default class FoodCard extends Card {

    onAfterCardThrownFromPlayerToUsedPile = async () => {
        if (this.playSoundOn === Constants.CARD_EVENT_ON_AFTER_CARD_THROWN_FROM_PLAYER_TO_USED_PILE) {
            this.gameCtx.soundRepository.playSoundByName(this.cardSound);
        }
    }

    onAfterPlayerGetCardFromNewPileOrUsedPile = (card, entityIndex) => {
        if (entityIndex === Constants.MY_PLAYER_INDEX && this.playSoundOn === Constants.CARD_EVENT_ON_AFTER_PLAYER_GET_CARD_FROM_NEW_PILE_OR_USED_PILE) {
            this.gameCtx.soundRepository.playSoundByName(this.cardSound);
        }
    }
}